<script setup=""></script>

<template>
  <svg fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.7309 5.33325C10.4425 5.33325 5.33325 9.46659 5.33325 14.5333C5.33325 17.7333 7.42936 20.5333 10.4425 22.2666L9.65648 26.6666L14.5037 23.4666C15.1588 23.5999 15.9448 23.5999 16.5998 23.5999C22.8882 23.5999 27.9975 19.4666 27.9975 14.3999C28.1285 9.46659 23.0192 5.33325 16.7309 5.33325Z"
      fill="currentColor"
    />
  </svg>
</template>
